module.exports = __webpack_public_path__ + "img/repost.e2b5a096.svg";